/**
 * Application Entrypoint
 * Mounts the root React component tree into the DOM node, wraps the app
 * in React.StrictMode and React Router's BrowserRouter provider.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize React 18 client root on the HTML #root DOM container
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render top-level component tree wrapped with Router context
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Optional Web Vitals performance reporting hook
reportWebVitals();
